(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 40186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ LayoutWithSidebar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);


var LayoutWithSidebar = function LayoutWithSidebar(_ref) {
  var className = _ref.className,
      sidebarContent = _ref.sidebarContent,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "layout-with-sidebar ".concat(className || ''),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "main-content",
      children: children
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "sidebar-content",
      children: sidebarContent
    })]
  });
};

/***/ }),

/***/ 83809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ RightSidebarContent; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(29051);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/store/src/user/selectors.ts
var selectors = __webpack_require__(42556);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_widgets/FreeTrialBanner/FreeTrialBanner.module.scss
var FreeTrialBanner_module = __webpack_require__(5390);
var FreeTrialBanner_module_default = /*#__PURE__*/__webpack_require__.n(FreeTrialBanner_module);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/FreeTrialBanner/FreeTrialBanner.tsx




var FreeTrialBanner = function FreeTrialBanner(_ref) {
  var freeTrialDaysLeft = _ref.freeTrialDaysLeft,
      isPermanent = _ref.isPermanent;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: isPermanent ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FreeTrialBanner_module_default())["free-trial-banner"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "Permanent Trial"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(FreeTrialBanner_module_default())["free-trial-banner"], freeTrialDaysLeft <= 0 && (FreeTrialBanner_module_default())["expiring-soon"]]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "Free Trial"
      }), freeTrialDaysLeft > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "".concat(freeTrialDaysLeft, " day").concat(freeTrialDaysLeft === 1 ? '' : 's', " left")
      }), freeTrialDaysLeft === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "Expires Today"
      }), freeTrialDaysLeft < 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "Expired"
      })]
    })
  });
};
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_atomics/Button/EvenButton.tsx
var EvenButton = __webpack_require__(24682);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_widgets/UpgradeBanner/UpgradeBanner.module.scss
var UpgradeBanner_module = __webpack_require__(17883);
var UpgradeBanner_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeBanner_module);
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/UpgradeBanner/UpgradeBanner.tsx




var UpgradeBanner = function UpgradeBanner(_ref) {
  var monthlyFee = _ref.monthlyFee,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: monthlyFee !== 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (UpgradeBanner_module_default())["upgrade-banner"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (UpgradeBanner_module_default())["upgrade-banner-text"],
        children: "Purchase a plan to continue using your integrations before trial period expires."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EvenButton/* EvenButton */.Z, {
        onClick: onClick,
        children: "Purchase Plan"
      })]
    })
  });
};
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/QuickLinks.tsx + 6 modules
var QuickLinks = __webpack_require__(16318);
// EXTERNAL MODULE: ./resources/saas/helpers.ts
var helpers = __webpack_require__(94248);
// EXTERNAL MODULE: ./resources/supply-migration/helpers.ts
var supply_migration_helpers = __webpack_require__(50941);
;// CONCATENATED MODULE: ./components/right-sidebar-content/index.tsx








var RightSidebarContent = function RightSidebarContent(_ref) {
  var hideFreeTrial = _ref.hideFreeTrial,
      freeTrialEndDate = _ref.freeTrialEndDate,
      supplyMigration = _ref.supplyMigration,
      isPermanent = _ref.isPermanent,
      showTrialBanner = _ref.showTrialBanner,
      showResources = _ref.showResources;
  var freeTrialDaysLeft = (0,helpers/* getFreeTrialDaysLeft */.Dl)(freeTrialEndDate);

  var _useSelector = (0,es/* useSelector */.v9)(selectors/* selectPermissions */.AI),
      showRebrandGuideAndAssetsLink = _useSelector.showRebrandGuideAndAssetsLink;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!hideFreeTrial && showTrialBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(FreeTrialBanner, {
      freeTrialDaysLeft: freeTrialDaysLeft,
      isPermanent: isPermanent
    }), !hideFreeTrial && supplyMigration && !isPermanent && /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeBanner, {
      monthlyFee: supplyMigration === null || supplyMigration === void 0 ? void 0 : supplyMigration.monthlyFee,
      onClick: function onClick() {
        supplyMigration && !(0,supply_migration_helpers/* isPermanentTrial */.xT)(supplyMigration) ? router.push('/account/upgrade') : router.push('/account/subscription');
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* QuickLinks */.g, {
      showRebrandGuideAndAssetsLink: showRebrandGuideAndAssetsLink,
      showResources: showResources !== null && showResources !== void 0 ? showResources : hideFreeTrial
    })]
  });
};

/***/ }),

/***/ 94584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ self_service; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(29051);
// EXTERNAL MODULE: ../../node_modules/antd/es/layout/index.js + 2 modules
var layout = __webpack_require__(63586);
// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(45455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ../../node_modules/lodash/pick.js
var pick = __webpack_require__(13888);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/store/src/account/actions.ts + 1 modules
var actions = __webpack_require__(29125);
// EXTERNAL MODULE: ../../libs/store/src/account/selectors.ts
var selectors = __webpack_require__(52668);
// EXTERNAL MODULE: ../../libs/store/src/payable/actions.ts
var payable_actions = __webpack_require__(52839);
// EXTERNAL MODULE: ../../libs/store/src/view-context/selectors.ts + 1 modules
var view_context_selectors = __webpack_require__(22545);
// EXTERNAL MODULE: ./components/layout-with-sidebar/index.tsx
var layout_with_sidebar = __webpack_require__(40186);
// EXTERNAL MODULE: ./components/right-sidebar-content/index.tsx + 2 modules
var right_sidebar_content = __webpack_require__(83809);
// EXTERNAL MODULE: ./components/self-service/home/index-regular.tsx + 7 modules
var index_regular = __webpack_require__(13094);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(42946);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ../../node_modules/antd/es/alert/index.js + 4 modules
var es_alert = __webpack_require__(68282);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ./components/free-trial-expired-banner/index.tsx





var FreeTrialExpiredBanner = function FreeTrialExpiredBanner(_ref) {
  var freeTrialDaysLeft = _ref.freeTrialDaysLeft;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(es_alert/* default */.Z, {
    closable: true,
    showIcon: true,
    className: "free-trial-expired-banner",
    description: "Your 30-day trial has expired. To regain access to your integration and continue using Control Center, activate one of the following plans.",
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
      className: "free-trial-expired-banner-icon",
      icon: pro_regular_svg_icons/* faCartShopping */.yYj
    }),
    message: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "message",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "message-title",
        children: "Trial Expired"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "message-note",
        children: freeTrialDaysLeft < -1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "".concat(-freeTrialDaysLeft, " days ago")
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "".concat(-freeTrialDaysLeft, " day ago")
        })
      })]
    }),
    type: "warning"
  });
};
// EXTERNAL MODULE: ./components/subscription-plans/index.tsx + 1 modules
var subscription_plans = __webpack_require__(44669);
;// CONCATENATED MODULE: ./components/self-service/home/index-trial-expired.tsx





var SelfServiceHomeTrialExpired = function SelfServiceHomeTrialExpired(_ref) {
  var freeTrialDaysLeft = _ref.freeTrialDaysLeft;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FreeTrialExpiredBanner, {
      freeTrialDaysLeft: freeTrialDaysLeft
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(subscription_plans/* default */.Z, {})]
  });
};

/* harmony default export */ var index_trial_expired = (SelfServiceHomeTrialExpired);
// EXTERNAL MODULE: ./resources/integrations/selectors.ts + 3 modules
var integrations_selectors = __webpack_require__(57728);
// EXTERNAL MODULE: ./resources/latest-invoices/selectors.ts
var latest_invoices_selectors = __webpack_require__(12751);
// EXTERNAL MODULE: ./resources/saas/helpers.ts
var helpers = __webpack_require__(94248);
// EXTERNAL MODULE: ./resources/saas/selectors.ts
var saas_selectors = __webpack_require__(84286);
// EXTERNAL MODULE: ./resources/saas/selects.ts
var selects = __webpack_require__(51033);
// EXTERNAL MODULE: ./resources/self-service/selectors.ts
var self_service_selectors = __webpack_require__(78177);
// EXTERNAL MODULE: ./resources/supply-migration/helpers.ts
var supply_migration_helpers = __webpack_require__(50941);
// EXTERNAL MODULE: ./resources/supply-migration/selects.ts
var supply_migration_selects = __webpack_require__(34607);
// EXTERNAL MODULE: ./resources/supply-sub-accounts/internal/selectors.ts
var internal_selectors = __webpack_require__(89109);
// EXTERNAL MODULE: ./resources/users/selectors.ts
var users_selectors = __webpack_require__(9701);
// EXTERNAL MODULE: ./store/compliance/actions.ts
var compliance_actions = __webpack_require__(910);
// EXTERNAL MODULE: ./store/saas/actions.ts
var saas_actions = __webpack_require__(89830);
// EXTERNAL MODULE: ./store/subaccount/actions.ts
var subaccount_actions = __webpack_require__(72155);
// EXTERNAL MODULE: ./store/supply-contracts/actions.ts
var supply_contracts_actions = __webpack_require__(42486);
// EXTERNAL MODULE: ./store/supply-migration/actions.ts
var supply_migration_actions = __webpack_require__(32897);
;// CONCATENATED MODULE: ./pages/home/self-service/index.tsx

































var ControlCenterHome = function ControlCenterHome() {
  var _useRouter = (0,router.useRouter)(),
      queryUnpicked = _useRouter.query,
      pathname = _useRouter.pathname,
      replace = _useRouter.replace;

  var account = (0,es/* useSelector */.v9)(selectors/* selectFirstAccount */.GF);
  var clientName = (0,es/* useSelector */.v9)(users_selectors/* nameSelector */.SZ);
  var integrations = (0,es/* useSelector */.v9)(integrations_selectors/* IntegrationsTableDataSelector */.$X);
  var latestInvoices = (0,es/* useSelector */.v9)(latest_invoices_selectors/* latestInvoicesSelector */.O);
  var saasSubscription = (0,es/* useSelector */.v9)(selects/* selectSaasSubscription */.G4);
  var saasUserPlan = (0,es/* useSelector */.v9)(saas_selectors/* saasUserPlanSelector */.Tz);
  var saasUserTrial = (0,es/* useSelector */.v9)(saas_selectors/* saasUserTrialSelector */.AF);
  var selfServiceData = (0,es/* useSelector */.v9)(self_service_selectors/* selfServiceDataSelector */.F);
  var subAccounts = (0,es/* useSelector */.v9)(internal_selectors/* selectSupplySubAccounts */.i6);
  var supplyMigration = (0,es/* useSelector */.v9)(supply_migration_selects/* selectSaasMigrationSettings */.V);

  var _useSelector = (0,es/* useSelector */.v9)(view_context_selectors/* viewContextSelector */.Z),
      showHomepageGuide = _useSelector.showHomepageGuide,
      hasCrmUserRole = _useSelector.hasCrmUserRole,
      shouldRedirectToWelcome = _useSelector.shouldRedirectToWelcome,
      shouldSkipTrialExpiredPage = _useSelector.shouldSkipTrialExpiredPage,
      showControlCenterHomeGettingStartedBox = _useSelector.showControlCenterHomeGettingStartedBox,
      showControlCenterHomeSetupBankingInformation = _useSelector.showControlCenterHomeSetupBankingInformation,
      showControlCenterHomeHeaderText = _useSelector.showControlCenterHomeHeaderText,
      showControlCenterSidebarTrialBanner = _useSelector.showControlCenterSidebarTrialBanner,
      showSidebarResources = _useSelector.showSidebarResources;

  var dispatch = (0,es/* useDispatch */.I0)();
  (0,react.useEffect)(function () {
    dispatch(supply_contracts_actions/* getSupplyContractsAll.request */.R9.request({}));
    dispatch(saas_actions/* saasAllRequestAction.request */.C2.request({}));
    dispatch(compliance_actions/* myAccountComplianceRequestAction.request */.y8.request({}));
    dispatch(payable_actions/* payableRequestAction.request */.wS.request({}));
    dispatch(actions/* accountRequestAction.request */.xr.request({}));
    dispatch(subaccount_actions/* supplySubAccountRequestAction.request */.kx.request({}));
    dispatch(supply_migration_actions/* getSettingsByAuthContextRequestAction.request */.Ij.request({}));
  }, [dispatch]);
  (0,react.useEffect)(function () {
    if (isEmpty_default()(saasUserTrial) && shouldRedirectToWelcome) {
      replace('/welcome');
    }
  }, [saasUserTrial]);

  if (hasCrmUserRole) {
    replace('/performance-summary');
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var query = pick_default()(queryUnpicked, ['publishSuccess', 'feePaymentSuccess', 'upgradedMigrationSuccess']);
  var isPaid = Boolean(selfServiceData.currentPlan);
  var freeTrialEndDate = saasUserTrial === null || saasUserTrial === void 0 ? void 0 : saasUserTrial.endDate;
  var freeTrialDaysLeft = (0,helpers/* getFreeTrialDaysLeft */.Dl)(freeTrialEndDate);
  var freeTrialExpired = freeTrialDaysLeft < 0;
  var isPermanent = (0,supply_migration_helpers/* isPermanentTrial */.xT)(supplyMigration);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "self-service-home-scope",
      children: [showControlCenterHomeHeaderText && /*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
        children: ["Welcome, ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: clientName
        }), "!"]
      }), freeTrialExpired && !saasSubscription && !supplyMigration && !shouldSkipTrialExpiredPage ? /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_trial_expired, {
          freeTrialDaysLeft: freeTrialDaysLeft
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_with_sidebar/* LayoutWithSidebar */.i, {
        sidebarContent: /*#__PURE__*/(0,jsx_runtime.jsx)(right_sidebar_content/* RightSidebarContent */.t, {
          freeTrialEndDate: freeTrialEndDate,
          hideFreeTrial: isPaid,
          isPermanent: isPermanent,
          showResources: showSidebarResources,
          showTrialBanner: showControlCenterSidebarTrialBanner,
          supplyMigration: supplyMigration
        }),
        children: [showHomepageGuide && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "new-feature",
          children: ["Learn more with\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/guide/home",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: "tutorial"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_regular/* SelfServiceHomeRegular */.Z, {
          account: account,
          clientName: clientName,
          integrations: integrations,
          isPermanent: isPermanent,
          latestInvoices: latestInvoices,
          pathname: pathname,
          query: query,
          saasUserPlan: saasUserPlan,
          selfServiceData: selfServiceData,
          showControlCenterHomeGettingStartedBox: showControlCenterHomeGettingStartedBox,
          showControlCenterHomeSetupBankingInformation: showControlCenterHomeSetupBankingInformation,
          subAccounts: subAccounts,
          supplyMigration: supplyMigration
        })]
      })]
    })
  });
};

/* harmony default export */ var self_service = (ControlCenterHome);

/***/ }),

/***/ 2715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _portal_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27656);
/* harmony import */ var _portal_common__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_portal_common__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _portal_store_src_user_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42556);
/* harmony import */ var _home_self_service_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94584);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);







var Home = function Home() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_portal_store_src_user_selectors__WEBPACK_IMPORTED_MODULE_3__/* .selectPermissions */ .AI),
      shouldRedirectIndexPageToAccount = _useSelector.shouldRedirectIndexPageToAccount,
      shouldUseExternalEntrypointOnIndexPage = _useSelector.shouldUseExternalEntrypointOnIndexPage,
      shouldUseSelfServiceEntrypointOnIndexPage = _useSelector.shouldUseSelfServiceEntrypointOnIndexPage,
      shouldRedirectIndexEntryPointToHomePage = _useSelector.shouldRedirectIndexEntryPointToHomePage,
      shouldRedirectIndexEntryPointToMciReports = _useSelector.shouldRedirectIndexEntryPointToMciReports,
      shouldRedirectIndexEntryPointToBenchmarkReports = _useSelector.shouldRedirectIndexEntryPointToBenchmarkReports;

  if (shouldRedirectIndexPageToAccount) {
    router.push('/accounts');
    return null;
  }

  if (shouldUseExternalEntrypointOnIndexPage) {
    if (shouldRedirectIndexEntryPointToHomePage) {
      router.push('/home');
      return null;
    }

    if (shouldRedirectIndexEntryPointToMciReports) {
      router.push(_portal_common__WEBPACK_IMPORTED_MODULE_2__.Route.MciReports);
      return null;
    }

    if (shouldRedirectIndexEntryPointToBenchmarkReports) {
      router.push('/benchmark-reports/funnel-summary');
      return null;
    }
  }

  if (shouldUseSelfServiceEntrypointOnIndexPage) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_home_self_service_index__WEBPACK_IMPORTED_MODULE_4__["default"], {});
  }

  return null;
};

/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 12751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ latestInvoicesSelector; },
/* harmony export */   "h": function() { return /* binding */ invoicesSelector; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_portal_portal_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _portal_store_src_account_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52668);
/* harmony import */ var _resources_payables_selects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69380);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_portal_portal_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var invoicesSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)([_resources_payables_selects__WEBPACK_IMPORTED_MODULE_3__/* .selectPayables */ .hX, _portal_store_src_account_selectors__WEBPACK_IMPORTED_MODULE_1__/* .selectAccounts */ .L3], function (invoices, accounts) {
  return invoices.map(function (invoice) {
    var account = accounts.find(function (a) {
      return a.id === invoice.accountId;
    });
    return _objectSpread(_objectSpread({}, invoice), {}, {
      accountUuid: account === null || account === void 0 ? void 0 : account.uuid,
      activityPeriod: [new Date(invoice.startDate), new Date(invoice.endDate)],
      status: invoice.reconciliationType
    });
  });
});
var latestInvoicesSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)([invoicesSelector], function (invoices) {
  return (invoices === null || invoices === void 0 ? void 0 : invoices.length) >= 3 ? invoices.slice(0, 3) : invoices;
});

/***/ }),

/***/ 69380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XD": function() { return /* binding */ selectPayableAdjustmentsForDetailPage; },
/* harmony export */   "ZQ": function() { return /* binding */ selectPayableAdjustments; },
/* harmony export */   "hX": function() { return /* binding */ selectPayables; }
/* harmony export */ });
var selectPayables = function selectPayables(state) {
  return state.payables.rows;
};
var selectPayableAdjustments = function selectPayableAdjustments(state) {
  return state.payables.adjustments;
};
var selectPayableAdjustmentsForDetailPage = function selectPayableAdjustmentsForDetailPage(state, id) {
  var _state$payables$adjus, _state$payables$adjus2;

  return (_state$payables$adjus = (_state$payables$adjus2 = state.payables.adjustmentsByLedgerItemId) === null || _state$payables$adjus2 === void 0 ? void 0 : _state$payables$adjus2[id]) !== null && _state$payables$adjus !== void 0 ? _state$payables$adjus : [];
};

/***/ }),

/***/ 38757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CopyToClipboardButton; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_portal_portal_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72282);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blueprintjs_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6455);
/* harmony import */ var _blueprintjs_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53450);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54933);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49929);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88133);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_portal_portal_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var CopyToClipboardButton = function CopyToClipboardButton(_ref) {
  var buttonProps = _ref.buttonProps,
      copyData = _ref.copyData,
      children = _ref.children;

  var onCopy = function onCopy() {
    return antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].success */ .ZP.success('Copied to clipboard!', 1);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default()), {
    text: copyData ? copyData : (children === null || children === void 0 ? void 0 : children.toString()) || '',
    onCopy: onCopy,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, _objectSpread(_objectSpread({
      outlined: true,
      icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faCopy */ .kZ_
      }),
      intent: _blueprintjs_core__WEBPACK_IMPORTED_MODULE_8__/* .Intent.PRIMARY */ .S.PRIMARY
    }, buttonProps), {}, {
      children: children === null || children === void 0 ? void 0 : children.toString()
    }))
  });
};

/***/ }),

/***/ 16318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ QuickLinks_QuickLinks; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/QuickLinks.scss
var QuickLinks = __webpack_require__(19412);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/Sections/SectionSupport.scss
var SectionSupport = __webpack_require__(69858);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_widgets/CopyToClipboardButton/CopyToClipboardButton.tsx
var CopyToClipboardButton = __webpack_require__(38757);
// EXTERNAL MODULE: ../../node_modules/@blueprintjs/core/lib/esm/components/index.js + 1188 modules
var components = __webpack_require__(6455);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/QuickLinkSection.tsx




var QuickLinkSection = function QuickLinkSection(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H5, {
      children: title
    }), subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components.H6, {
      children: subtitle
    }), children]
  });
};

/* harmony default export */ var QuickLinks_QuickLinkSection = (QuickLinkSection);
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/Sections/SectionSupport.tsx




var SectionSupport_SectionSupport = function SectionSupport() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(QuickLinks_QuickLinkSection, {
    subtitle: "Questions? Get in touch!",
    title: "Support",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "mailto:partnersupport@engine.tech",
        children: "partnersupport@engine.tech"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CopyToClipboardButton/* CopyToClipboardButton */.m, {
      buttonProps: {
        className: 'quick-links-support-copy-to-clipboard-button',
        outlined: true
      },
      copyData: "partnersupport@engine.tech",
      children: "Copy Email"
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_atomics/FontAwesomeIcon/types.ts
var types = __webpack_require__(29602);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_atomics/FontAwesomeIcon/FontAwesomeKitIcon.tsx
var FontAwesomeKitIcon = __webpack_require__(25886);
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/QuickLinkSectionItem.tsx




var QuickLinkSectionItem = function QuickLinkSectionItem(_ref) {
  var href = _ref.href,
      icon = _ref.icon,
      kitIcon = _ref.kitIcon,
      target = _ref.target,
      title = _ref.title;
  var iconStyle = {
    height: 'auto',
    width: 16
  };
  var Icon = icon ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
    fixedWidth: true,
    icon: icon,
    style: iconStyle
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(FontAwesomeKitIcon/* FontAwesomeKitIcon */.J, {
    fixedWidth: true,
    icon: kitIcon,
    style: iconStyle
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
    className: "quick-link-section-item",
    href: href,
    target: target,
    children: [Icon, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "quick-link-section-item-title",
      children: title
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/Sections/SectionQuickLinks.tsx






var SectionQuickLinks = function SectionQuickLinks(_ref) {
  var _ref$showRebrandGuide = _ref.showRebrandGuideAndAssetsLink,
      showRebrandGuideAndAssetsLink = _ref$showRebrandGuide === void 0 ? false : _ref$showRebrandGuide;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(QuickLinks_QuickLinkSection, {
    title: "Quick Links",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "https://engine.tech/docs/api-reference/#overview",
      kitIcon: types/* KitIconNames.ApiSolid */.Im.ApiSolid,
      target: "_blank",
      title: "API Reference"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "https://engine.tech/control-center/guides/reporting",
      icon: pro_solid_svg_icons/* faChartPie */.OS1,
      target: "_blank",
      title: "Analytics"
    }), showRebrandGuideAndAssetsLink ? /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "https://engine.tech/s3/announcements/",
      icon: pro_solid_svg_icons/* faEngine */.gPP,
      target: "_blank",
      title: "Rebrand Guide & Assets"
    }) : null]
  });
};
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/Sections/SectionLearnMore.tsx




var SectionLearnMore = function SectionLearnMore() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(QuickLinks_QuickLinkSection, {
    title: "Learn More",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "https://engine.tech/developer-center/integrations/api/products/loans/personal",
      icon: pro_solid_svg_icons/* faLandmark */.wDC,
      target: "_blank",
      title: "Personal Loans"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "https://engine.tech/developer-center/integrations/api/products/loans/personal",
      icon: pro_solid_svg_icons/* faGraduationCap */.Xf_,
      target: "_blank",
      title: "Student Loan Refinancing"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "https://engine.tech/developer-center/integrations/api/products/loans/heloc",
      icon: pro_solid_svg_icons/* faHouse */.wp6,
      target: "_blank",
      title: "HELOC"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "https://engine.tech/developer-center/integrations/api/products/loans/auto-refinancing",
      icon: pro_solid_svg_icons/* faCarSide */.lft,
      target: "_blank",
      title: "Auto Loan Refinancing"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "https://engine.tech/developer-center/integrations/api/products/savings",
      icon: pro_solid_svg_icons/* faCoins */.owJ,
      target: "_blank",
      title: "Savings"
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/Sections/SectionResources.tsx




var SectionResources = function SectionResources() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(QuickLinks_QuickLinkSection, {
    title: "Resources",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "/docs/master-services-agreement.pdf",
      icon: pro_solid_svg_icons/* faDownload */.q7m,
      title: "Master Services Agreement"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinkSectionItem, {
      href: "/docs/control-center-addendum.pdf",
      icon: pro_solid_svg_icons/* faDownload */.q7m,
      title: "Control Center Addendum"
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/_widgets/QuickLinks/QuickLinks.tsx




var QuickLinks_QuickLinks = function QuickLinks(_ref) {
  var _ref$showRebrandGuide = _ref.showRebrandGuideAndAssetsLink,
      showRebrandGuideAndAssetsLink = _ref$showRebrandGuide === void 0 ? false : _ref$showRebrandGuide,
      _ref$showResources = _ref.showResources,
      showResources = _ref$showResources === void 0 ? false : _ref$showResources,
      _ref$showSupport = _ref.showSupport,
      showSupport = _ref$showSupport === void 0 ? true : _ref$showSupport;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "quick-links-container",
    children: [showSupport && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionSupport_SectionSupport, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionQuickLinks, {
      showRebrandGuideAndAssetsLink: showRebrandGuideAndAssetsLink
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLearnMore, {}), showResources && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionResources, {})]
  });
};

/***/ }),

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2715);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"free-trial-banner":"FreeTrialBanner_free-trial-banner__BNhgh","expiring-soon":"FreeTrialBanner_expiring-soon__mXqr3"};

/***/ }),

/***/ 17883:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-banner":"UpgradeBanner_upgrade-banner__ZCodH","upgrade-banner-text":"UpgradeBanner_upgrade-banner-text__B3HbT"};

/***/ }),

/***/ 19412:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 69858:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 36794:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(62610));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  function CopyToClipboard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyToClipboard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, ["text", "onCopy", "options", "children"]);

      var elem = _react["default"].Children.only(children);

      return _react["default"].cloneElement(elem, _objectSpread({}, props, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 72282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(36794),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 62610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(91706);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3480,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);